import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../vuex/store';

const BookingIndex = () => import('Views/BookingIndex');

/** Basket */
const Basket = () => import('Views/basket/TheBasket');

/** Checkout */
const Checkout = () => import('Views/checkout/TheCheckout');

/** Complete */
const BookingComplete = () => import('Views/complete/BookingComplete');

/** Contact */
const ContactPage = () => import('Views/contact/ContactIndex');

/** Terms and privacy */
const TermsPage = () => import('Views/terms/TermsIndex');
const PrivacyPage = () => import('Views/terms/PrivacyIndex');
const AppTermsPage = () => import('Views/terms/AppTermsIndex');

/** Customer Details */
const CustomerDetails = () => import('Views/details/CustomerDetails');

/** Device Select */
const ConfirmDamage = () => import('Views/device/ConfirmDamage');
const DeviceColour = () => import('Views/device/DeviceColour');
const DeviceFaultType = () => import('Views/device/DeviceFaultType');
const DeviceTriage = () => import('Views/device/Triage');
const DeviceInsuranceStatus = () => import('Views/device/DeviceInsuranceStatus');
const DeviceMake = () => import('Views/device/DeviceMake');
const DeviceModel = () => import('Views/device/DeviceModel');
const DeviceType = () => import('Views/device/DeviceType');
const DeviceWarrantyStatus = () => import('Views/device/DeviceWarrantyStatus');
const Extras = () => import('Views/device/Extras');
const RepairSelect = () => import('Views/device/SelectRepair');

/** FAQs */
const BookingFaqs = () => import('Views/faqs/categories/BookingFaqs');
const FaqsPage = () => import('Views/faqs/FaqsIndex');
const GuaranteeFaqs = () => import('Views/faqs/categories/GuaranteeFaqs');
const LocationFaqs = () => import('Views/faqs/categories/LocationFaqs');
const PaymentsFaqs = () => import('Views/faqs/categories/PaymentsFaqs');
const RepairFaqs = () => import('Views/faqs/categories/RepairFaqs');
const TermsFaqs = () => import('Views/faqs/categories/TermsFaqs');

/** Location */
const Postcode = () => import('Views/location/PostcodeSearch');
const AddressSearch = () => import('Views/location/AddressSearch');
const RepairLocation = () => import('Views/location/SelectLocation');
const RepairOptions = () => import('Views/location/RepairOptions');
const RepairOptionsExternal = () => import('Views/location/RepairOptionsExternal');

const DropOffLocationDetails = () => import('Views/location/dropOff/DropOffLocationDetails');
const DropOffLocationSelect = () => import('Views/location/dropOff/DropOffLocationSelect');

const StoreSearch = () => import('Views/location/StoreSearch');
const InStoreBookingConfirmation = () => import('Views/inStoreBooking/InStoreBookingConfirmation');

/** Payment Options */
const PaymentOptions = () => import('Views/payment/PaymentOptions');
const DoorstepPayment = () => import('Views/payment/DoorstepPayment');

/** Repair Dates */
const RepairDates = () => import('Views/date/SelectDate');

/** Manage Booking */
const ManageBookingIndex = () => import('Views/manageBooking/ManageBookingIndex');
const ManageBooking = () => import('Views/manageBooking/ManageBooking');
const TrackTechnician = () => import('Views/manageBooking/TrackTechnician');
const ConfirmBooking = () => import('Views/manageBooking/ConfirmBooking');

/** Landing Page */
const LandingPage = () => import('Views/landingPages/LandingPageIndex');

const PartnerRepairHome = () => import('Views/landingPages/partner/PartnerRepairHome');
const BookingCompletionLanding = () => import('Views/landingPages/partner/BookingCompletion');

/** Maintenance Page */
 const Maintenance = () => import('Views/Maintenance');

Vue.use(VueRouter);

const index = [
    /** Booking */
    {
        path: '/booking',
        name: 'booking',
        component: BookingIndex,
        props: true,
        redirect: {name: 'postcodeSearch'},
        children: [
            {
                path: 'start',
                name: 'partnerRepairHome',
                component: PartnerRepairHome,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Book Repairs'
                }
            },
            {
                path: 'continue',
                name: 'bookingCompletionLanding',
                component: BookingCompletionLanding,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Finalise your booking'
                }
            },
            /** Basket */
            {
                path: 'basket',
                name: 'basket',
                component: Basket,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Basket'
                }
            },

            /** Checkout */
            {
                path: 'checkout',
                name: 'checkout',
                component: Checkout,
                props: true,
                meta: {
                    pageSection: 'checkout',
                    title: 'Checkout'
                }
            },

            /** Booking Complete */
            {
                path: 'complete',
                name: 'bookingComplete',
                component: BookingComplete,
                props: true,
                meta: {
                    pageSection: 'complete',
                    title: 'Booking Complete'
                }
            },

            /** Customer Details */
            {
                path: 'details',
                name: 'customerDetails',
                component: CustomerDetails,
                props: true,
                meta: {
                    pageSection: 'details',
                    title: 'Details'
                }
            },

            /**
             * Device Select
             */

            {
                path: 'device',
                redirect: {name: 'deviceMake'}
            },

            /** Colour */
            {
                path: 'device/colour',
                name: 'deviceColour',
                component: DeviceColour,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Colour'
                }
            },

            /** Confirm Damage */
            {
                path: 'device/confirm-damage',
                name: 'confirmDamage',
                component: ConfirmDamage,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Confirm Damage'
                }
            },

            /** Extras */
            {
                path: 'device/extras',
                name: 'extras',
                component: Extras,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Extras'
                }
            },

            /** Fault Type */
            {
                path: 'device/fault-type',
                name: 'deviceFaultType',
                component: DeviceFaultType,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Fault Type'
                }
            },

            /** Triage */
            {
                path: 'device/triage',
                name: 'deviceTriage',
                component: DeviceTriage,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Appliance Faults'
                }
            },

            /** Insurance Status */
            {
                path: 'device/insurance-status',
                name: 'deviceInsuranceStatus',
                component: DeviceInsuranceStatus,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Insurance Status'
                }
            },

            /** Make */
            {
                path: 'device/make',
                name: 'deviceMake',
                component: DeviceMake,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Make'
                }
            },


            /** Model */
            {
                path: 'device/model',
                name: 'deviceModel',
                component: DeviceModel,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Model'
                }
            },

            /** Repair Select */
            {
                path: 'device/select',
                name: 'repairSelect',
                component: RepairSelect,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Issues'
                }
            },

            /** Type */
            {
                path: 'device/type',
                name: 'deviceType',
                component: DeviceType,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Select Type'
                }
            },

            /** Warranty Status */
            {
                path: 'device/warranty-status',
                name: 'deviceWarrantyStatus',
                component: DeviceWarrantyStatus,
                props: true,
                meta: {
                    pageSection: 'device',
                    title: 'Warranty Status'
                }
            },

            /**
             * Location
             */

            /** Drop-off Location */
            {
                path: 'drop-off-locations/location',
                name: 'dropOffLocationDetails',
                component: DropOffLocationDetails,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Drop-off Location'
                }
            },

            /** Drop-off Location Select */
            {
                path: 'drop-off-locations',
                name: 'dropOffLocationSelect',
                component: DropOffLocationSelect,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Drop-off Location Select'
                }
            },

            /** Postcode Search */
            {
                path: 'postcode-search',
                name: 'postcodeSearch',
                component: Postcode,
                props: true,
                meta: {
                    // pageSection: 'device',
                    title: 'Postcode Search'
                },
                beforeEnter: (to, __, next) => {

                    // If we're using loqate we don't want to use the postcode page so redirect to address search
                    if (store.getters.useLoqate) {
                        return next("/booking/address-search");
                    }

                    next();
                },
            },

            /** Address Search */
            {
                path: 'address-search',
                name: 'addressSearch',
                component: AddressSearch,
                props: true,
                meta: {
                    title: 'Address Search'
                }
            },

            /** Repair Location */
            {
                path: 'repair-location',
                name: 'repairLocation',
                component: RepairLocation,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Repair Location'
                }
            },

            /** Store Search */
            {
                path: 'store-search',
                name: 'storeSearch',
                component: StoreSearch,
                props: true,
                meta: {
                    title: 'Select Store'
                }
            },

            /** Repair Options */
            {
                path: 'repair-options',
                name: 'repairOptions',
                component: RepairOptions,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Repair Options'
                }
            },
            /** Repair Options */
            {
                path: 'repair-type',
                name: 'repairOptionsExternal',
                component: RepairOptionsExternal,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Repair Options'
                }
            },

            /**
             * Payment Options
             */

            {
                path: 'payment',
                name: 'paymentOptions',
                component: PaymentOptions,
                props: true,
                meta: {
                    pageSection: 'checkout',
                    title: 'Payment Options'
                }
            },

            /**
             * Repair Dates
             */

            {
                path: 'repair-date',
                name: 'repairDates',
                component: RepairDates,
                props: true,
                meta: {
                    pageSection: 'repair',
                    title: 'Repair Dates'
                }
            },

            /** Store Search */
            {
                path: 'in-store-booking-confirmation',
                name: 'inStoreBookingConfirmation',
                component: InStoreBookingConfirmation,
                props: true,
                meta: {
                    pageSection: 'complete',
                    title: 'In Store Booking Confirmation'
                }
            },
        ]
    },
    /** Doorstep Payments (WEF-1240) */
    {
        path: '/doorstep/payment',
        name: 'doorstep-payment',
        component: DoorstepPayment,
        meta: {
            title: 'Pay for your Repair',
            showLiveChat: false
        },
    },
    /** Contact */
    {
        path: '/contact',
        name: 'Contact',
        component: ContactPage,
        props: true,
        meta: {
            title: 'Contact Us',
            showLiveChat: true,
        }
    },
    /** FAQs */
    {
        path: '/faqs',
        name: 'Faqs',
        component: FaqsPage,
        props: true,
        meta: {
            title: 'Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        },
    },
    {
        path: '/faqs/booking',
        name: 'BookingFaqs',
        component: BookingFaqs,
        props: true,
        meta: {
            title: 'Booking Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    {
        path: '/faqs/guarantee',
        name: 'GuaranteeFaqs',
        component: GuaranteeFaqs,
        props: true,
        meta: {
            title: 'Guarantee Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    {
        path: '/faqs/location',
        name: 'LocationFaqs',
        component: LocationFaqs,
        props: true,
        meta: {
            title: 'Location Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    {
        path: '/faqs/payments',
        name: 'PaymentsFaqs',
        component: PaymentsFaqs,
        props: true,
        meta: {
            title: 'Pricing and Payment Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    {
        path: '/faqs/repair',
        name: 'RepairFaqs',
        component: RepairFaqs,
        props: true,
        meta: {
            title: 'Repair Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    {
        path: '/faqs/terms',
        name: 'TermsFaqs',
        component: TermsFaqs,
        props: true,
        meta: {
            title: 'Terms and Conditions Frequently Asked Questions',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    /** Manage Booking Index */
    {
        path: '/manage',
        name: 'manageBookingIndex',
        component: ManageBookingIndex,
        props: true,
        meta: {
            pageSection: 'manageOrder',
            title: 'Manage Booking'
        }
    },
    /** Manage My Booking */
    {
        path: '/manage/booking',
        name: 'manageBooking',
        component: ManageBooking,
        props: true,
        meta: {
            pageSection: 'manageOrder',
            title: 'Manage My Booking'
        }
    },
    /** Confirm My Booking */
    {
        path: '/manage/confirm',
        name: 'confirmBooking',
        component: ConfirmBooking,
        meta: {
            pageSection: 'manageOrder',
            title: 'Confirm My Booking',
            requiresOrder: true,
        }
    },
    /** Privacy */
    {
        path: '/privacy',
        name: 'Privacy',
        component: PrivacyPage,
        props: true,
        meta: {
            title: 'Privacy policy',
            showLiveChat: true
        }
    },
    /** Terms */
    {
        path: '/terms',
        name: 'Terms',
        component: TermsPage,
        props: true,
        meta: {
            title: 'Terms and Conditions',
            showLiveChat: true
        }
    },
    /** App Terms */
    {
        path: '/app-terms',
        name: 'AppTerms',
        component: AppTermsPage,
        props: true,
        meta: {
            title: 'Terms of Application',
            showLiveChat: true
        }
    },
    /** Track My Technician */
    {
        path: '/my/technician/:email/:orderRef',
        name: 'trackTechnician',
        component: TrackTechnician,
        props: true,
        meta: {
            pageSection: 'trackTechnician',
            title: 'Track My Technician'
        }
    },
    /** Landing Page */
    {
        path: '/',
        name: 'Landing',
        component: LandingPage,
        props: true,
        meta: {
            title: 'Repairs',
            showLiveChat: true,
            carrierOnly: true
        }
    },
    {
        path: '',
        redirect: {name: 'postcodeSearch'},
    },
    /** Maintenance Page */
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        props: true,
        meta: {
            title: 'Booking down for Maintenance'
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    carrier: process.env.CARRIER_CODE,
    routes: index,
    scrollBehavior (to) {
            if (to.hash) {
                return {selector: to.hash}
            } else {
                return { x: 0, y: 0 }
            }
    },
});

router.beforeEach((to, from, next) => {

    let carrier = store.getters.carrierDetails;

    if (to.path !== '/maintenance' && process.env.VUE_APP_MAINTENANCE_MODE) {
        next('/maintenance');
    } else if (to.path === '/maintenance' && !process.env.VUE_APP_MAINTENANCE_MODE) {
        next('/');
    }

    if (carrier.redirect) {
        window.location.replace(carrier.redirect);
    }

    if (to.meta.requiresOrder && store.getters.orderLoaded === false) {
        next('/manage');
    }

    if (carrier.name === 'likewize-confirm' && to.meta.carrierOnly) {
        next("/booking/address-search");
    }

    // check to see if the route we are attempting to go to has the meta tag
    if(to.meta.showLiveChat && to.meta.showLiveChat === true && carrier && carrier.liveChat) {
        // Check to see if the widget has already been initialised, if not, load it.
        if(document.getElementById('chat-widget-container')) {
            // Widget has been initialised, show it.
            document.getElementById('chat-widget-container').style.display = 'block';
        } else {
            // Initialise the widget, and then show it.
            window.__lc = window.__lc || {};
            window.__lc.license = 12034224;
            (function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
            window.LiveChatWidget.on('ready', () => document.getElementById('chat-widget-container').style.display = 'block');
        }
    } else {
        // Hide if the widget has been initialised.
        if(document.getElementById('chat-widget-container')) {
            document.getElementById('chat-widget-container').style.display = 'none';
        }
    }

    window.scrollTo(0, 0);

    to.matched.some(() => {
        next();
    });

});

router.afterEach(() => {
    window.scrollTo(0,0)
});

export default router
